import React from 'react'
import './styles.css'

export default () => {

  return(
    <fb className="">

    </fb>
  )
}



// WEBPACK FOOTER //
// ./src/containers/apps/userProfile/userColor/index.js